<template>
  <div class="invoice-history-item">
    <div class="invoice-history-item__info">
      <p>{{ invoice.displayInvoiceDate || invoice.invoiceDate }}</p>
      <oie-base-dot></oie-base-dot>
      <p class="invoice-history-item__link">
        {{ t('headerInvoiceNumber') }}: <button class="invoice-history-item__invoice-details-button" :aria-label="`Open invoice with OCR ${invoice.ocr}`" @click="handleSelectInvoice(invoice)">
          {{ invoice.ocr }}
        </button>
      </p>
      <oie-base-dot></oie-base-dot>
      <p class="invoice-history-item__link">
        {{ t('headerOrderNumber') }}: <a
          v-for="(orderNumber, index) in orderNumberArray"
          :key="index"
          :href="`${clientModel.orderHistoryDetailUrl}?orderNumber=${orderNumber}`"
          class="invoice-history-item__invoice-details-button"
          :aria-label="`Open order ${orderNumber}`">
          {{ orderNumber }}
        </a>
      </p>
    </div>
    <oie-my-machines-list-wrapper>
      <li v-for="(row, i) in invoice.invoiceRows" :key="`${row.articleNumber}-${i}`">
        <oie-invoice-history-row :invoice-row="row"></oie-invoice-history-row>
      </li>
    </oie-my-machines-list-wrapper>
  </div>
</template>

<script>
import myPages from '@/mixins/my-pages'
import { mapGetters, mapActions } from 'vuex'

export default {
  mixins: [myPages],
  props: {
    invoice: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters('myInvoiceHistory', ['myMachines', 'myMachinesFilter', 'filteredMachineOwners', 'filteredMachines']),
    orderNumberArray() {
      let str = this.invoice.orderNumber
      let lastIndex = str.lastIndexOf(';')

      if (lastIndex !== -1) {
        str = str.slice(0, lastIndex) + str.slice(lastIndex + 1)
      }

      lastIndex = str.lastIndexOf(';')
      if (lastIndex !== -1) {
        return str.split(';')
      } else {
        return [str]
      }
    }
  },
  methods: {
    ...mapActions('myInvoiceHistory', ['setCurrentInvoice']),
    handleSelectInvoice(invoice) {
      this.setCurrentInvoice(invoice)
      this.goToSubPage(this.navigationOptions.oieInvoiceHistoryDetails)
    }
  }
}
</script>

<style lang="scss">
.invoice-history-item__info {
  @include caption;
  display: flex;
  align-items: center;
  margin-bottom: measure(eighth);

}

.invoice-history-item__info>*:not(:last-child) {
  margin-right: measure(eighth);
}

.invoice-history-item__link {
  position: relative;
}

.invoice-history-item__link a {
  @include reset-link;
}

/*
.invoice-history-item__link a::after {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
}
*/

  .invoice-history-item__invoice-details-button {
    background-color: transparent;
    color: rgb(0, 136, 200);
    text-decoration: none;
    border: none;
  }

  .invoice-history-item__invoice-details-button:hover {
    text-decoration: underline
  }
</style>
